import { render, staticRenderFns } from "./GridOData.vue?vue&type=template&id=19a80730&scoped=true&"
import script from "./GridOData.vue?vue&type=script&lang=ts&"
export * from "./GridOData.vue?vue&type=script&lang=ts&"
import style0 from "./GridOData.vue?vue&type=style&index=0&id=19a80730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a80730",
  null
  
)

export default component.exports